import React from "react";
import type { DocDataGrid_ItemFragment } from "../../features/doc-data-grid/DocDataGrid.generated.js";
import type { ExpandedStore } from "./useExpandedStore.js";

export function useEnrichExpandedStoreWithItemIds<
  I extends DocDataGrid_ItemFragment,
>(
  expandedStore: ExpandedStore,
  items: I[],
  ready: boolean,
  showExpandButton?: (item: I) => boolean
) {
  React.useEffect(() => {
    if (ready && expandedStore.areAllItemsExpanded) {
      expandedStore.setItemsExpanded(
        items
          .filter(
            item =>
              !item.isRootItem && (showExpandButton?.(item) ?? item.hasChildren)
          )
          .map(i => i.id),
        true
      );
    }
  }, [expandedStore, items, ready]);
}
